<template>
    <div class="activate-box">
        <div id="temp_activate_iframe" style="width: 500px; height: 500px;">
            <iframe :src="url" seamless="seamless" width="100%" height="100%"></iframe>
        </div>
    </div>
</template>

<script setup>

    import {ref, onBeforeMount, onMounted, onBeforeUnmount} from "vue";
    import myUtil from "@/util/util";

    const props = defineProps(["id", "code"])
    const emits = defineEmits(["activate-complete"])

    const url = ref("")

    function messageCallback(e){
        if (e.data.type == "check"){
            emits("activate-complete", -1)
        }
    }

    onBeforeMount(() => {
        window.addEventListener("message", messageCallback)
        url.value = myUtil.generateActivateUrl(props.id, props.code)
    })

    onBeforeUnmount(() => {
        window.removeEventListener("message", messageCallback)
    })

</script>

<style scoped>
    .activate-box {
        width: 1000px;
        height: 1000px;
        position: fixed;
        top: 200vh;
        left: 0;
    }
</style>